<template>
  <b-dropdown class="mt-3" variant="info" size="sm" :disabled="isLoading" right>
    <template v-slot:button-content>
      <font-awesome-icon v-if="!isLoading" icon="download" />
      <b-spinner v-else class="mr-1" small />

      <template v-if="!isLoading">ดาวน์โหลดเอกสาร</template>
      <template v-else>กำลังสร้างเอกสาร...</template>
    </template>
    <b-dropdown-item @click="download('proposal', 'pdf')"><font-awesome-icon :icon="['far', 'file-pdf']" />แบบขออนุมัติโครงการ (PDF)</b-dropdown-item>
    <b-dropdown-item v-if="isEvaluationPdfAvailable" @click="download('evaluation', 'pdf')"><font-awesome-icon :icon="['far', 'file-pdf']" />แบบประเมินผล (PDF)</b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item @click="download('proposal', 'html')"><font-awesome-icon :icon="['far', 'file-code']" />แบบขออนุมัติโครงการ (HTML)</b-dropdown-item>
    <b-dropdown-item v-if="isEvaluationPdfAvailable" @click="download('evaluation', 'html')"><font-awesome-icon :icon="['far', 'file-code']" />แบบประเมินผล (HTML)</b-dropdown-item>
  </b-dropdown>
</template>

<script>
import gql from 'graphql-tag'

export default {
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) },
    isEvaluationPdfAvailable () {
      return (
        this.project.status === 'Approved' ||
        this.project.status === 'AwaitingForClosureApproval' ||
        this.project.status === 'Closed' ||
        this.project.status === 'DraftForCloseProjectApproval' ||
        this.project.status === 'WaitingFotHeadOfProjectCloseProjectApproval' ||
        this.project.status === 'WaitingForHeadOfGroupCloseProjectApproval' ||
        this.project.status === 'WaitingForAdvisorCloseProjectApproval' ||
        this.project.status === 'WaitingForStudentCouncilCloseProjectApproval' ||
        this.project.status === 'WaitingForFacultyStaffCloseProjectApproval' ||
        this.project.status === 'WaitingForFacultyDeanCloseProjectApproval'
      )
    }
  },
  methods: {
    async download (type, format) {
      try {
        this.isLoading = true

        if (format === 'pdf') {
          // PDF
          const result = await (type === 'proposal' ? this.downloadProposalPdf() : this.downloadEvaluationPdf())
          window.open(result.data[(type === 'proposal' ? 'projectDownloadPdf' : 'projectDownloadEvaluationPdf')].file)
        } else {
          // HTML
          const result = await (type === 'proposal' ? this.downloadProposalHtml() : this.downloadEvaluationHtml())
          const newWindow = window.open()
          newWindow.document.write(result.data[(type === 'proposal' ? 'projectDownloadHtml' : 'projectDownloadEvaluationHtml')].html)
        }
      } catch (error) {
        this.$bvToast.toast('เกิดข้อผิดพลาดในสร้างเอกสาร กรุณาติดต่อผู้ดูแลระบบ', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isLoading = false
      }
    },
    downloadProposalPdf () {
      return this.$apollo.query({
        query: gql`query ($id: ID!) { projectDownloadPdf (id: $id) { file } }`,
        variables: { id: this.$route.params.id },
        fetchPolicy: 'no-cache',
        loadingKey: 'pdfDownload'
      })
    },
    downloadEvaluationPdf () {
      return this.$apollo.query({
        query: gql`query ($id: ID!) { projectDownloadEvaluationPdf (id: $id) { file } }`,
        variables: { id: this.$route.params.id },
        fetchPolicy: 'no-cache',
        loadingKey: 'pdfDownload'
      })
    },
    downloadProposalHtml () {
      return this.$apollo.query({
        query: gql`query ($id: ID!) { projectDownloadHtml (id: $id) { html } }`,
        variables: { id: this.$route.params.id },
        fetchPolicy: 'no-cache',
        loadingKey: 'htmlDownload'
      })
    },
    downloadEvaluationHtml () {
      return this.$apollo.query({
        query: gql`query ($id: ID!) { projectDownloadEvaluationHtml (id: $id) { html } }`,
        variables: { id: this.$route.params.id },
        fetchPolicy: 'no-cache',
        loadingKey: 'htmlEvaluation'
      })
    }
  }
}
</script>
